import React, { useState, useRef, useEffect } from "react";
import "./EditOrganizationModal.css";
import { useDispatch } from "react-redux";
import CloseButton from "../CloseButton/CloseButton";
import { updateOrganization } from "../../store/usersSlice";

const EditOrganizationModal = ({ organization, onClose, onSave }) => {
  const dispatch = useDispatch();
  const [orgName, setOrgName] = useState(organization?.title || "");
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (organization) {
      setOrgName(organization.title || "");
    }
    setIsLoading(false);
  }, [organization]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSubmit = () => {
    if (!orgName.trim()) return;

    setIsLoading(true);
    dispatch(
      updateOrganization({
        id: organization.id,
        title: orgName.trim(),
        description: "test desc",
      })
    ).then((res) => {
      if (!res.error) {
        onSave();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="edit-org-modal-overlay">
      <div className="edit-org-modal" ref={modalRef}>
        <button className="edit-org-close-button" onClick={onClose} />
        <h1 className="edit-org-modal-title">Переименовать организацию</h1>
        <CloseButton onClose={onClose} />
        <div className="edit-org-modal-content">
          <input
            className="edit-org-input"
            type="text"
            placeholder="Название организации"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            maxLength={64}
            autoFocus
          />
        </div>
        <button
          onClick={handleSubmit}
          className="edit-org-submit-button"
          disabled={isLoading || !orgName.trim()}
        >
          {isLoading ? "Сохранение..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default EditOrganizationModal;
